import axios from 'axios';
import { parse } from 'qs';

export interface ResUpbitCoin {
  baseCurrencyCode: string  // 해당 코인 Symbol
  quoteCurrencyCode: string // 마켓 (KRW,USDT,BTC)
  marketState: string
  exchange: string
}

export const bithumb = async () => {
  const url = 'https://api.bithumb.com/public/ticker/ALL';
  const config: any = {
    method: 'get',
    url,
  }
  
  let { data: resData } = await axios(config);
  
  return Object.keys(resData.data).map((coin: any) => ({
    name: `${coin}_KRW`,
    open: parseFloat(resData.data[coin].opening_price),
    close: parseFloat(resData.data[coin].closing_price),
    volume: parseFloat(resData.data[coin].acc_trade_value)
  }))
}

export const cobit = async () => {
  const url = "https://ajax.korbit.co.kr/graphql"
  const data = {
    query: 'query { markets { id base counter tickSize pusher { channel events type } maintenance { marketOrderState serviceState serviceStatus } } }'
  };
  const config: any = {
    method: 'post',
    url,
    headers: {
      //  'Cookie': '__cfduid=d7a2a74fb20daa6f4b1d580e0f4ad74621615097679'
    },
    data
  };

  let { data: resData, status } = await axios(config)
  return resData.data.markets.map((coin: any) => ({
    name: `${coin.base}_krw`,
    open: 0,
    close: 0,
    volume: 0
  }))
}

export const upbit = async () => {
  const url = 'https://s3.ap-northeast-2.amazonaws.com/crix-production/crix_master?nonce=1615175959953';

  const config: any = {
    method: 'get',
    url
  }

  let { data: resData, status } = await axios(config)
  return resData
    .filter((coin: ResUpbitCoin) => coin.quoteCurrencyCode === 'KRW' && coin.marketState === 'ACTIVE' && coin.exchange === 'UPBIT')
    .map((coin: ResUpbitCoin) => ({
      name: `${coin.quoteCurrencyCode}-${coin.baseCurrencyCode}`,
      open: 0,
      close: 0,
      volume: 0
    }))
}